// src/mixins/clickMixin.js

import moment from "moment";

export default {
    methods: {
        simple_format_date(date) {
            return moment(date).format("MM-DD-YY");
        },
        reverse_simple_format_date(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        custom_format_date(date, format) {
            return moment(date).format(format);
        },
        format_date(date) {
            let return_val = null;
            if (date) {
                let now = moment();
                let moment_date = moment(date);

                let diff_in_days = moment_date.diff(now, "days");
                return_val = moment(date).format("MMM Do YY");
                if (diff_in_days > 0 && diff_in_days < 8) {
                    let day = "days";
                    if (diff_in_days === 1) day = "day";
                    return_val = diff_in_days + " " + day;
                }
                if (diff_in_days < 0) {
                    return_val = "Expired";
                }
            }

            return return_val;
        }
    },
};
